import { Amplify } from 'aws-amplify';
import { signIn, signUp, signOut, fetchAuthSession, confirmSignUp, getCurrentUser } from 'aws-amplify/auth';
import React, { createContext, useEffect, useState } from "react";
import { LOCAL_STORAGE_KEY } from '../const/general';
import { jwtDecode } from 'jwt-decode';

Amplify.configure({
    Auth: {
        Cognito: {
            region: LOCAL_STORAGE_KEY.REGION,
            userPoolId: LOCAL_STORAGE_KEY.USER_POOL_ID,
            userPoolClientId: LOCAL_STORAGE_KEY.CLI_ID,
        },
    },
});

export const AuthContext = createContext();

const AuthContextProvider = (props) => {
    const [isLoading, setIsLoading] = useState(true);
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState((''));
    const [availableTabs, setAvailableTabs] = useState(null);
    const [defaultCities, setDefaultCities] = useState(null);
    const [defaultUnit, setDefaultUnit] = useState(null);
    const [enabledPrefs, setEnabledPrefs] = useState(null);

    useEffect(() => {
        const fetchUserData = async () => {
            try {
                const result = await getCurrentUser();
                setUsername(result.username);
                setIsAuthenticated(true);

                // カスタム属性取得
                const session = await fetchAuthSession();
                const idToken = session.tokens?.idToken?.toString();

                if (idToken) {
                    const decoded = jwtDecode(idToken);

                    // カスタム属性取得
                    const dsbd_available_tabs = decoded['custom:dsbd_available_tabs'];
                    const dsbd_default_cities = decoded['custom:dsbd_default_cities'];
                    const dsbd_default_unit = decoded['custom:dsbd_default_unit'];
                    const enabled_prefs = decoded['custom:enabled_prefs'];

                    setAvailableTabs(dsbd_available_tabs);
                    setDefaultCities(dsbd_default_cities);
                    setDefaultUnit(dsbd_default_unit);
                    setEnabledPrefs(enabled_prefs);
                }

                setIsLoading(false);
            } catch (error) {
                setUsername('');
                setIsAuthenticated(false);
                setIsLoading(false);
            }
        };

        fetchUserData();
    }, []);

    const signUpFunc = async (username, password) => {
        try {
            await signUp({ username, password });
            setUsername(username);
            setPassword(password);
            return { success: true, message: '' };
        } catch (error) {
            return {
                success: false,
                message: '認証に失敗しました。'
            };
        }
    };

    const confirmSignUpFunc = async (verificationCode) => {
        try {
            await confirmSignUp(username, verificationCode);
            const result = await signIn(username, password);
            setPassword('');
            return result;
        } catch (error) {
            return {
                success: false,
                message: '認証に失敗しました。'
            };
        }
    };

    const signInFunc = async (username, password) => {
        try {
            // idTokenが存在する（サインイン済み）場合、サインアウトする
            const fetched = await fetchAuthSession();
            if (fetched.tokens !== undefined) {
                await signOut();
            }

            // 引数がオブジェクトになっている
            const result = await signIn({ username, password });
            setUsername(result.username);
            setIsAuthenticated(true);

            // v6からsignIn後のレスポンスにsubが入らないためsubが欲しいなら再度fetchする必要がある
            const fetchedResult = await fetchAuthSession();
            const idToken = fetchedResult.tokens?.idToken?.toString();

            if (idToken) {
                const decoded = jwtDecode(idToken);

                // カスタム属性取得
                const dsbd_available_tabs = decoded['custom:dsbd_available_tabs'];
                const dsbd_default_cities = decoded['custom:dsbd_default_cities'];
                const dsbd_default_unit = decoded['custom:dsbd_default_unit'];
                const enabled_prefs = decoded['custom:enabled_prefs'];

                setAvailableTabs(dsbd_available_tabs);
                setDefaultCities(dsbd_default_cities);
                setDefaultUnit(dsbd_default_unit);
                setEnabledPrefs(enabled_prefs);
            }
            return { success: true, message: '' };
        } catch (error) {
            console.log(error);
        }
    };

    const signOutFunc = async () => {
        try {
            await signOut();
            setUsername('');
            setAvailableTabs(null);
            setDefaultCities(null);
            setDefaultUnit(null);
            setEnabledPrefs(null);
            setIsAuthenticated(false);
            return { success: true, message: '' };
        } catch (error) {
            return {
                success: false,
                message: 'ログアウトに失敗しました。'
            };
        }
    };

    return (
        <AuthContext.Provider
            value={{
                isLoading,
                isAuthenticated,
                username,
                availableTabs,
                defaultCities,
                defaultUnit,
                enabledPrefs,
                isLoading,
                signUpFunc,
                confirmSignUpFunc,
                signInFunc,
                signOutFunc
            }}
        >
            {props.children}
        </AuthContext.Provider>
    );
};
export default AuthContextProvider;